"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveModel = void 0;
var Model_1 = __importDefault(require("../Model"));
var LiveModel = /** @class */ (function (_super) {
    __extends(LiveModel, _super);
    function LiveModel(live, getters) {
        var _this = _super.call(this, getters) || this;
        _this.id = live.id;
        _this.name = live.name;
        _this.sourceId = live.sourceId;
        _this.sourceType = live.sourceType;
        _this.providerAccountId = live.providerAccountId || null;
        _this.avatarUrl = live.avatarUrl || null;
        return _this;
    }
    Object.defineProperty(LiveModel.prototype, "url", {
        get: function () {
            var sourceType = (this.sourceType || '').toLowerCase().trim();
            if (sourceType === 'kaltura' || sourceType === 'youtube' || sourceType === 'lap') {
                return this.sourceId;
            }
            else if (sourceType === 'zoom') {
                var meetingID = this.sourceId.replace(/\s/g, '');
                return "https://us02web.zoom.us/j/" + meetingID;
            }
            else if (sourceType === 'livestream') {
                var livestreamUrl = "https://livestream.com/accounts/" + this.providerAccountId + "/events/" + this.sourceId + "/player";
                return livestreamUrl;
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    return LiveModel;
}(Model_1.default));
exports.LiveModel = LiveModel;
